/**
 * Application configuration
 * Prefers deploy-time window.__APP_CONFIG__ (runtime-config.js), then CRA .env at build time.
 */

import { runtimeEnv } from './runtimeConfig';

// Get package.json version dynamically
const packageJson = require('../package.json');

const { string: env } = runtimeEnv;

export const config = {
  // API URLs
  apiUrl: env('apiUrl', 'REACT_APP_API_URL'),
  extractorApiUrl: env('extractorApiUrl', 'REACT_APP_EXTRACTOR_API_URL'),
  analysisApiUrl: env('analysisApiUrl', 'REACT_APP_ANALYSIS_API_URL'),
  gatewayUrl: env('gatewayUrl', 'REACT_APP_GATEWAY_URL', 'http://localhost:8000'),
  protocolKbChatUrl: env('protocolKbChatUrl', 'REACT_APP_PROTOCOL_KB_CHAT_URL'),
  protocolKbApiUrl: env('protocolKbApiUrl', 'REACT_APP_PROTOCOL_KB_API_URL'),
  apiDomain: env('apiDomain', 'REACT_APP_API_DOMAIN', 'api.hel.signanthealth.dev'),

  // Application Info
  appName: 'Protocol Genie',
  appVersion: packageJson.version,
  brandName: env('brandName', 'REACT_APP_BRAND_NAME', 'Signant SmartSignals'),
  applicationUserFacingName: env(
    'applicationUserFacingName',
    'REACT_APP_APPLICATION_USER_FACING_NAME',
    'ai-protocol-genie-client'
  ),
  publicName: env(
    'publicName',
    'REACT_APP_PUBLIC_NAME',
    'ai-protocol-genie-client | Signant Health'
  ),
  applicationPath: env('applicationPath', 'REACT_APP_APPLICATION_PATH'),
  themeName: env('themeName', 'REACT_APP_THEME_NAME') || null,

  // Build Configuration
  cssPrefix: env('cssPrefix', 'REACT_APP_CSS_PREFIX', 'ai-protocol-genie-client_css'),
  scssPrefix: env('scssPrefix', 'REACT_APP_SCSS_PREFIX', 'ai-protocol-genie-client_scss'),
  devServerPort: env('devServerPort', 'REACT_APP_DEV_SERVER_PORT', '3000'),

  // Pagination
  defaultPageSize: (() => {
    const raw = runtimeEnv.int('defaultPageSize', 'REACT_APP_DEFAULT_PAGE_SIZE', NaN);
    return [5, 10, 50].includes(raw) ? raw : 5;
  })(),

  // Okta Authentication
  oktaIssuer: env('oktaIssuer', 'REACT_APP_OKTA_ISSUER'),
  oktaClientId: env('oktaClientId', 'REACT_APP_OKTA_CLIENT_ID'),

  // Application Switcher (ID Portal)
  idPortalClientAppName: env('idPortalClientAppName', 'ID_PORTAL_CLIENT_APP_NAME'),
  idPortalUrl: env('idPortalUrl', 'ID_PORTAL_URL'),
  idPortalApiUrl: env('idPortalApiUrl', 'ID_PORTAL_API_URL'),
};

// Validate required configuration
if (!config.apiUrl) {
  console.error(
    '❌ REACT_APP_API_URL is not set!\n' +
    'Set it in the .env file for this deploy target or in runtime-config.js at deploy time.'
  );
}

// Validate Okta configuration
if (!config.oktaIssuer || !config.oktaClientId) {
  console.error(
    '❌ Okta configuration is incomplete!\n' +
    `  - Okta Issuer: ${config.oktaIssuer || 'NOT SET'}\n` +
    `  - Okta Client ID: ${config.oktaClientId || 'NOT SET'}\n` +
    'Set REACT_APP_OKTA_ISSUER and REACT_APP_OKTA_CLIENT_ID in the env file for this target.'
  );
}
